"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dimension = void 0;
/*
 * @Author: 林健忠
 * @Date: 2024-03-12 15:43:09
 * @LastEditTime: 2024-06-13 11:15:37
 * @LastEditors: 林健忠
 * @Description:
 * @FilePath: \ts_cad\business\dimension\dimension.ts
 */
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const tolerance = 0.1;
const angleTolerance = 1 * Math.PI / 180;
const dimOffset = 400; //标注线的偏移
class Dimension {
    constructor(point0, point1, roomLocalCenter, drawscale) {
        //为了调整过程不影响原本的点，这里copy一份
        point0 = new Coordinate_js_1.default(point0);
        point1 = new Coordinate_js_1.default(point1);
        //调整两个点的顺序
        //通过判断相对房间中心的方向来决定向哪边偏移
        let vector = new Vector2D_js_1.default(point0, point1);
        let angle = vector.angle(); //范围应该为-180°~180°
        if (angle <= Math.PI / 2 + angleTolerance && angle >= -1 * (Math.PI / 2 - angleTolerance)) {
            this._point0 = point0;
            this._point1 = point1;
        }
        else { //<-90或>90的情况将两个点倒过来
            this._point0 = point1;
            this._point1 = point0;
        }
        this._isAboveCenter = this.computeIsAboveCenter(new Coordinate_js_1.default(roomLocalCenter.x, roomLocalCenter.y));
        let seg = new LineSegment_js_1.default(this._point0, this._point1);
        let midPoint = seg.midPoint();
        let segAngle = seg.angle();
        let dim_vec = new Vector2D_js_1.default(0, this._isAboveCenter ? dimOffset * drawscale : -1 * dimOffset * drawscale);
        dim_vec = dim_vec.rotate(segAngle);
        this._dim_point = new Coordinate_js_1.default(midPoint.x + dim_vec.getX(), midPoint.y + dim_vec.getY());
        this._text_pos = new Coordinate_js_1.default(midPoint.x + dim_vec.getX(), midPoint.y + dim_vec.getY());
    }
    equals(other, isRow) {
        if (isRow) {
            return (Math.abs(this._point0.y - other._point0.y) < tolerance && Math.abs(this._point1.y - other._point1.y) < tolerance)
                || (Math.abs(this._point0.y - other._point1.y) < tolerance && Math.abs(this._point1.y - other._point0.y) < tolerance);
        }
        else {
            return (Math.abs(this._point0.x - other._point0.x) < tolerance && Math.abs(this._point1.x - other._point1.x) < tolerance)
                || (Math.abs(this._point0.x - other._point1.x) < tolerance && Math.abs(this._point1.x - other._point0.x) < tolerance);
        }
    }
    computeIsAboveCenter(roomLocalCenter) {
        let isHorizontal = this._point0.y == this._point1.y;
        if (isHorizontal) {
            return this._point0.y >= roomLocalCenter.y;
        }
        else {
            return this._point0.x <= roomLocalCenter.x;
        }
    }
}
exports.Dimension = Dimension;
